import gql from 'graphql-tag';

export const requestLoginMutation = gql`
  mutation RequestLogin($tenant: String!, $userIdentifier: UserIdentifierInput!) {
    requestLogin(tenant: $tenant, userIdentifier: $userIdentifier)
  }
`;